import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { hostInfo } from '../server';

function ConfigForm() {
  const navigate = useNavigate();

  const [data, setdata] = useState({
    host: "",
    port: "",
    username: "",
    password: "",
    database: "",
  });
  const saveConfiguration = (e) => {
    e.preventDefault();
    const url = hostInfo + "/saveConfiguration/";

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          // onSubmit();
          setdata({
            host: "",
            port: "",
            username: "",
            password: "",
            database: "",
          });
          navigate(`/dashbord`, { state: { database: data.database } });
        } else {
          alert(data.error);
        }
      })
      .catch((error) => console.error("Error:", error));
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setdata((prevData) => ({ ...prevData, [name]: value }));
  };
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "0px auto",
      }}
    >
      <main
        style={{
          backgroundColor: "#f4f4f4",
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h2 style={{ textAlign: "center", marginTop: "-5px" }}>
          Database Configuration
        </h2>
        <div style={{ margin: "10px 0" }}>
          <label>Host:</label>
          <br />
          <input
            name="host"
            value={data.host}
            onChange={handleChange}
            placeholder="Enter host..."
            style={{
              // padding: "10px",
              width: "100%",
              // boxSizing: "border-box",
              minWidth: "400px",
              // marginBottom: "10px",
              // marginTop: "10px",
              // borderRadius: "10px",

              padding: "10px",
              // width: "100%",
              boxSizing: "border-box",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginTop: "5px",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>

        <div style={{ margin: "10px 0" }}>
          <label>Port:</label>
          <br />
          <input
            name="port"
            value={data.port}
            onChange={handleChange}
            placeholder="Enter port..."
            style={{
              // padding: "10px",
              width: "100%",
              // boxSizing: "border-box",
              minWidth: "400px",
              // marginBottom: "20px",
              // marginTop: "10px",
              // borderRadius: "10px",

              padding: "10px",
              // width: "100%",
              boxSizing: "border-box",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginTop: "5px",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>

        <div style={{ margin: "10px 0" }}>
          <label>Username:</label>
          <br />
          <input
            name="username"
            value={data.username}
            onChange={handleChange}
            placeholder="Enter username..."
            style={{
              // padding: "10px",
              width: "100%",
              // boxSizing: "border-box",
              minWidth: "400px",
              // marginBottom: "20px",
              // marginTop: "10px",
              // borderRadius: "10px",

              padding: "10px",
              // width: "100%",
              boxSizing: "border-box",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginTop: "5px",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>

        <div style={{ margin: "10px 0" }}>
          <label>Password:</label>
          <br />
          <input
            name="password"
            value={data.password}
            onChange={handleChange}
            type="password"
            placeholder="Enter password..."
            style={{
              // padding: "10px",
              width: "100%",
              // boxSizing: "border-box",
              minWidth: "400px",
              // marginBottom: "20px",
              // marginTop: "10px",
              // borderRadius: "10px",

              padding: "10px",
              // width: "100%",
              boxSizing: "border-box",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginTop: "5px",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>

        <div style={{ margin: "10px 0" }}>
          <label>Database:</label>
          <br />
          <input
            name="database"
            value={data.database}
            onChange={handleChange}
            placeholder="Enter database name..."
            style={{
              // padding: "10px",
              width: "100%",
              // boxSizing: "border-box",
              minWidth: "400px",
              // marginBottom: "20px",
              // marginTop: "10px",
              // borderRadius: "10px",

              padding: "10px",
              // width: "100%",
              boxSizing: "border-box",
              borderRadius: "8px",
              border: "1px solid #ccc",
              marginTop: "5px",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>

        <button
          onClick={saveConfiguration}
          style={{
            // textAlign: "right",
            padding: "10px 10px",
            boxSizing: "border-box",
            borderRadius: "8px",
            backgroundColor: "#2F4F4F",
            color: "white",
            border: "none",
            marginTop: "10px",
            cursor: "pointer",
            fontSize: "16px",
          }}
        >
          Save Configuration
        </button>
      </main>
    </div>
  );
}

export default ConfigForm;
